import React,{ Component } from 'react';

import {
  Row,
  Col,
  Button,
  FormText
} from 'reactstrap';

import findIndex from 'lodash/findIndex';
import find from 'lodash/find';

import CollapsingSection from '../../../shared/components/CollapsingSection';
import PhonePreview from '../../../shared/components/PhonePreview';
import ScrollWatcher from '../../../shared/components/ScrollWatcher';
import PaymentForm from '../../../shared/components/PaymentForm';
import ProgressEllipses from '../../../shared/components/ProgressEllipses';
import TutorialPopover from '../../../shared/components/TutorialPopover';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';

import CampaignOverview from './CampaignOverview';
import CampaignPromoCodeForm from './CampaignPromoCodeForm';
import CampaignPaymentForm from './CampaignPaymentForm';
import CampaignPublisherForm from './CampaignPublisherForm';

import {
  getWindowHeight,
  formatIncompleteEngagements,
  formatPaymentMethod,
  formatPromoCode,
  humanReadableList,
  alertApprovers,
  getApprovalLinkForCampaign
} from '../../../shared/utils';

import { ACTIVE_PROFILE } from '../../../config';

const PAYMENT_SECTION = '__PAYMENT_SECTION__',
  PROMO_CODE_SECTION = '__PROMO_CODE_SECTION__',
  PUBLISHERS_SECTION = '__PUBLISHERS_SECTION__';

const CREATE_NEW_PAYMENT_METHOD_OPTION = '__CREATE_NEW_PAYMENT_METHOD_OPTION__',
  CREATE_NEW_INVOICE_METHOD_OPTION = '__CREATE_NEW_INVOICE_METHOD_OPTION__',
  CREATE_NEW_ADJOY_PAYS_METHOD_OPTION = '__CREATE_NEW_ADJOY_PAYS_METHOD_OPTION__',
  AVAILABLE_FUNDS_METHOD_OPTION = '__AVAILABLE_FUNDS_METHOD_OPTION__',
  CURRENT_BALANCE_METHOD_OPTION = '__CURRENT_BALANCE_METHOD_OPTION__';

const NAVBAR_HEIGHT = 72;

const MINIMUM_NUMBER_OF_ENGAGEMENTS = 1;

const MAXIMUM_PREVIEW_HEIGHT = 600;

class GuidedCampaignReview extends Component {
  constructor(){
    super();

    this.state = {
      isLoading:true,
      isSaving:false,
      isShowingPopover:false,
      isUsingExistingFunds:false,
      activeSection:null,
      activePreviewEngagementId:'__FEED__',
      previewIsFixed:false,
      stripeToken:null,
      stripeValidationMessages:{},
      hasViewedPreview:false,
      showQAAnswer:false,
      promoCodeFeedback:''
    };
  }

  componentWillMount(){
    if(this.props.isOnboarding){
      this.setState({isShowingPopover:true});
    }

  }

  componentDidMount(){
    const loadingPromises = [];

    loadingPromises.push(this.props.loadCampaign(this.props.campaignId));
    loadingPromises.push(this.props.loadEngagementsForCampaign(this.props.campaignId));
    loadingPromises.push(this.props.loadAccountHistory(this.props.campaignId));
    loadingPromises.push(this.props.loadPublishersForCampaign(this.props.campaignId));
    loadingPromises.push(this.props.loadCampaignReach(this.props.campaignId))
    loadingPromises.push(this.props.loadListOfStatesAndDMAs());
    loadingPromises.push(this.props.loadRetailers());

    Promise
      .all(loadingPromises)
      .then(() => {
        const moreLoadingPromises = [];

        moreLoadingPromises.push(this.props.loadPaymentMethodsForAgency(this.props.activeCampaign.agencyId));
        moreLoadingPromises.push(this.props.loadAccountHistory(this.props.activeCampaign.agencyId));

        if(!this.props.activeAgency.name){
          moreLoadingPromises.push(this.props.loadAgency(this.props.activeCampaign.agencyId));
        }

        if(!this.props.activeBrand.name){
          moreLoadingPromises.push(this.props.loadBrand(this.props.activeCampaign.companyId));
        }

        if(this.props.activeCampaign.promoCodeId){
          moreLoadingPromises.push(this.props.loadPromoCode(this.props.activeCampaign.promoCodeId));
        }

        return Promise.all(moreLoadingPromises);
      })
      .then(() => {
        if(this.props.activeCampaign.paymentMethodId && this.props.activeCampaign.paymentMethodId.length > 0){
          console.log('USING A PAYMENT METHOD');
        } else if(this.props.activeCampaign.paymentMethodId && this.props.activeCampaign.paymentMethodId === ""){
          console.log('USING EXISTING FUNDS');
        } else {
          console.log('NO PAYMENT SELECTED');
        }

        if(this.props.showSuperadminFeatures){
          this.setState({activeSection:PUBLISHERS_SECTION});
        } else {
          if(!this.props.activeCampaign.promoCodeId){
            this.setState({activeSection:PROMO_CODE_SECTION});
          } else if(!this.props.activeAgencyPaymentMethod){
            this.setState({activeSection:PAYMENT_SECTION});
          } else {
            this.setState({activeSection:null});
          }
        }
      })
      .then(() => this.setState({isLoading:false}));

    window.scrollTo(0,0);

  }

  handleScroll(top){
    if(top > (NAVBAR_HEIGHT - 10) && !this.state.previewIsFixed){
      this.setState({previewIsFixed:true});
    }

    if(top <= (NAVBAR_HEIGHT - 10) && this.state.previewIsFixed){
      this.setState({previewIsFixed:false})
    }
  }

  handleSubmitClick(){
    const { forwardURL, campaignId, submitCampaign, history, showNotification } = this.props,
      url = forwardURL ? forwardURL : `/welcome/tutorial/${campaignId}/success`;

    this.setState({isSaving:true});
    this.balanceAccounts()
      .then(() => submitCampaign(campaignId))
      .then((res) => this.handleAlertApproversIfNeeded(res))
      .then(() => this.setState({isSaving:false}))
      .then(() => history.push(url))
      .catch((err) => showNotification('error',err.message));

  }

  handleAlertApproversIfNeeded(res){

    const {
      activeCampaign,
      activeBrand,
      activeAgency
    } = this.props;

    console.log('MY PROPS ARE',this.props);

    if(res.update.status === 'pendingAdjoy' && ACTIVE_PROFILE === 'prod'){
      const url = getApprovalLinkForCampaign(activeCampaign)
      //function alertApprovers(campaign,url,salesId,account,brand,startDate)
      alertApprovers(activeCampaign.name,url,activeCampaign.salesNumber,activeAgency.name,activeBrand.name,activeCampaign.launchDate);
    }
  }

  handleBackClick(){
    const { backURL, campaignId, history } = this.props,
      url = backURL ? backURL : `/welcome/tutorial/${campaignId}/payment`;

    history.push(url);
  }

  handleStripeTokenSubmit(token){
    const {
      createPaymentMethod,
      updateAgency,
      updateCampaign,
      activeCampaign
    } = this.props;

    this.setState({isSaving:true});

    createPaymentMethod({
      token:token.id,
      last4:token.card.last4,
      kind:'card',
      agencyId:activeCampaign.agencyId
    })
      .then((res) => Promise.all([
        updateAgency(activeCampaign.agencyId,{ defaultPaymentMethodId:res.instance.id }),
        updateCampaign(activeCampaign.id,{ paymentMethodId:res.instance.id })
      ]))
      .then(() => this.setState({
        isSaving:false,
        activeSection:null
      }));
  }

  handleDefaultCreditCardSubmit(){
    const {
      activeAgencyPaymentMethod,
      activeCampaign,
      updateCampaign
    } = this.props;

    updateCampaign(activeCampaign.id,{ paymentMethodId:activeAgencyPaymentMethod.id })
      .then(() => this.setState({
        activeSection:null,
        isUsingExistingFunds:false
      }));
  }

  handleExistingFundsSubmit(){
    const {
      activeCampaign,
      campaignAccountingBalance,
      agencyAccountingBalance,
      updateCampaign
    } = this.props;

    this.setState({isSaving:true});

    updateCampaign(activeCampaign.id,{ paymentMethodId:'' })
      .then(() => this.setState({
        isUsingExistingFunds:true,
        isSaving:false,
        activeSection:null
      }));

    // if(activeCampaign.lifetimeBudget > (agencyAccountingBalance + campaignAccountingBalance)){
    //   this.props.showNotification('error','Not enough available funds. Please decrease threshold value or add additional funds to your account balance.');
    //   this.setState({
    //     isSaving:false
    //   });
    // } else {
    //   this.setState({
    //     isSaving:false,
    //     activeSection:null
    //   });
    // }
  }

  handlePromoCodeSubmit(data){
    const {
      validatePromoCodeForAgency,
      activeCampaign,
      loadPromoCode,
      updateCampaign,
      loadAccountHistory
    } = this.props;

    if(!data.code || data.code === ''){
      updateCampaign(activeCampaign.id,{ promoCodeId:'' })
        .then(() => loadAccountHistory(activeCampaign.id))
        .then(() => this.setState({ isSaving:false, activeSection:PAYMENT_SECTION }));

    } else {
      validatePromoCodeForAgency(data.code,activeCampaign.agencyId)
        .then((res) => {
          if(!res.valid){
            this.setState({ promoCodeFeedback:res.message });

          } else {
            this.setState({ isSaving:true, activeSection:null });

            Promise.all([
              updateCampaign(activeCampaign.id,{ promoCodeId:res.id }),
              loadPromoCode(res.id)
            ])
              .then(() => loadAccountHistory(activeCampaign.id))
              .then(() => this.setState({ isSaving:false, activeSection:PAYMENT_SECTION }));
          }
        });
    }
  }

  handleNextClick(){
    if(this.state.activePreviewEngagementId === '__FEED__'){
      this.setState({
        activePreviewEngagementId:this.props.activeEngagements[0].id
      });
    } else {
      const indexOfCurrent = findIndex(this.props.activeEngagements,(e) => e.id === this.state.activePreviewEngagementId),
        currentEngagement = find(this.props.activeEngagements,(e) => e.id === this.state.activePreviewEngagementId);

      if(currentEngagement.kind === 'qa' && !this.state.showQAAnswer){
        this.setState({showQAAnswer:true});

      } else if(indexOfCurrent === this.props.activeEngagements.length - 1){
        this.setState({
          activePreviewEngagementId:'__CONCLUSION__',
          hasViewedPreview:true
        });
      } else {
        this.setState({
          showQAAnswer:false,
          activePreviewEngagementId:this.props.activeEngagements[indexOfCurrent + 1].id
        });
      }
    }
  }

  handlePreviousClick(){
    if(this.state.activePreviewEngagementId === '__CONCLUSION__'){
      this.setState({
        activePreviewEngagementId:this.props.activeEngagements[this.props.activeEngagements.length - 1].id
      });
    } else {
      const indexOfCurrent = findIndex(this.props.activeEngagements,(e) => e.id === this.state.activePreviewEngagementId),
        currentEngagement = find(this.props.activeEngagements,(e) => e.id === this.state.activePreviewEngagementId);

      if(currentEngagement.kind === 'qa' && !this.state.showQAAnswer){
        this.setState({
          showQAAnswer:true
        });

      } else if(indexOfCurrent === 0){
        this.setState({
          activePreviewEngagementId:'__FEED__'
        });

      } else {
        this.setState({
          activePreviewEngagementId:this.props.activeEngagements[indexOfCurrent -1].id
        });
      }
    }
  }

  handlePublishersSubmit(data){
    this.props.updatePublishersForCampaign(this.props.campaignId,data.publisherIds);
    if(!this.props.activeCampaign.promoCodeId){
      this.setState({activeSection:PROMO_CODE_SECTION});
    } else {
      this.setState({activeSection:PAYMENT_SECTION});
    }
  }

  balanceAccounts(){
    const {
      isUsingExistingFunds
    } = this.state;

    const {
      lifetimeBudget,
      agencyId,
      id,
      paymentMethodId
    } = this.props.activeCampaign;

    const {
      campaignAccountingBalance,
      agencyAccountingBalance,
      isOnboarding,
      addFundsToAgency,
      addFundsToCampaignFromAgency,
      removeFundsFromCampaignToAgency,
      addFundsToCampaignDirectly,
      showSuperadminFeatures,
      removeFundsFromCampaignDirectly
    } = this.props;

    if(isUsingExistingFunds){
      if((lifetimeBudget - campaignAccountingBalance) > agencyAccountingBalance){
        return Promise.reject(new Error('Not enough available funds. Please decrease threshold value or add additional funds to your account balance.'));
      } else if(lifetimeBudget === campaignAccountingBalance){
        return Promise.resolve();
      } else if(lifetimeBudget > campaignAccountingBalance && agencyAccountingBalance >= (lifetimeBudget - campaignAccountingBalance)){
        return addFundsToCampaignFromAgency(agencyId,null,id,lifetimeBudget - campaignAccountingBalance);
      } else if(lifetimeBudget < campaignAccountingBalance){
        return removeFundsFromCampaignToAgency(agencyId,null,id, campaignAccountingBalance - lifetimeBudget);
      } else {
        return Promise.reject(new Error('Bad Existing Funds State :('));
      }

    } else {
      if(lifetimeBudget === campaignAccountingBalance){
        return Promise.resolve();
      } else if(lifetimeBudget > campaignAccountingBalance){
        return addFundsToCampaignDirectly(paymentMethodId,id,lifetimeBudget - campaignAccountingBalance);
      } else if(lifetimeBudget < campaignAccountingBalance){
        return removeFundsFromCampaignDirectly(agencyId,paymentMethodId,id,campaignAccountingBalance - lifetimeBudget);
      } else {
        return Promise.reject(new Error('Bad Self Serve State :('));
      }
    }
  }

  getPaymentSectionSubtitle(){
    const {
      showSuperadminFeatures,
      agencyAccountingBalance,
      campaignAccountingBalance,
      activeAgencyPaymentMethod,
      activeCampaign
    } = this.props;

    if(!activeCampaign.paymentMethodId && showSuperadminFeatures){
      return (<span>Existing Funds: <MoneyDisplay>{agencyAccountingBalance}</MoneyDisplay></span>)
    } else if(activeCampaign.paymentMethodId && activeCampaign.paymentMethodId.length > 0){
      return (<span>Default Credit Card</span>)
    } else if(agencyAccountingBalance > 0){
      return (<span>Existing Funds: <MoneyDisplay>{agencyAccountingBalance}</MoneyDisplay></span>)
    } else {
      return (<span></span>)
    }
  }

  getPublishersSectionSubtitle(){
    const {
      activeCampaign,
      retailers
    } = this.props;

    const { isLoading } = this.state;

    if(isLoading){
      return (<i>Loading</i>)
    } else if(!activeCampaign.publisherIds || activeCampaign.publisherIds.length === 0){
      return (<i>None</i>)
    } else if(activeCampaign.publisherIds.length === retailers.length){
      return (<span>Nationwide Dabbl Network</span>)
    } else {
      let selectedPublisherNames = retailers.filter((r) => activeCampaign.publisherIds.indexOf(r.id) >= 0).map((r) => r.name);

      return (<span>{humanReadableList(selectedPublisherNames)}</span>)
    }
  }

  render(){
    const {
      activeSection,
      isSaving,
      isLoading,
      activePreviewEngagementId,
      previewIsFixed,
      isShowingPopover,
      showQAAnswer,
      promoCodeFeedback
    } = this.state;

    const {
      activeCampaign,
      activeBrand,
      activeEngagements,
      activePaymentMethods,
      activeAgency,
      invalidEngagementIndexes,
      allRequiredFieldsFilled,
      showSuperadminFeatures,
      activePaymentMethod,
      isOnboarding,
      isCampaignEditable,
      allowCreateNewMethod,
      agencyAccountingBalance,
      campaignAccountingBalance,
      activeAgencyPaymentMethod,
      activePromoCode,
      retailers,
      possibleStates,
      possibleGeoFilters
    } = this.props;

    const previewHeight = getWindowHeight() - 320;

    return (
      <div >
        <TutorialPopover
          placement='left'
          target='AdvancePreviewButton'
          title='Review your campaign'
          open={isShowingPopover && isOnboarding && !isLoading}
          onCloseClick={() => this.setState({isShowingPopover:false})}
        >
          <p>
            Review what consumers will see before submitting
          </p>
        </TutorialPopover>
        <Row className='GuidedCampaignReview'>
          <ScrollWatcher onScroll={(top) => this.handleScroll(top)} />
          <Col xs='8'>
            <br />
            <h3>Review & Submit</h3>
            <p>
              {(activeEngagements.length >= MINIMUM_NUMBER_OF_ENGAGEMENTS && invalidEngagementIndexes.length > 0) ? (
                <FormText className='DangerFeedback'>
                  {formatIncompleteEngagements(invalidEngagementIndexes)}
                </FormText>
              ) : (
                <span>
                  Let's get this party started!
                </span>
              )}
            </p>
            <Row>
              <Col xs='8'>
                <CampaignOverview
                  activePromoCode={activePromoCode || {}}
                  activeCampaign={activeCampaign || {}}
                  activeEngagements={activeEngagements || []}
                  possibleGeoFilters={possibleGeoFilters || []}
                />
              </Col>
            </Row>
            <Row>
              <Col xs='12'>
                <CollapsingSection
                  open={activeSection ===  PUBLISHERS_SECTION}
                  onOpenClick={() => this.setState({activeSection:PUBLISHERS_SECTION})}
                  title='Publishers'
                  subtitle={this.getPublishersSectionSubtitle()}
                  titleWidthInColumns={4}
                  locked={!showSuperadminFeatures}
                >
                  {isLoading ? (
                    <span>Loading<ProgressEllipses /></span>
                  ) : (
                    <CampaignPublisherForm
                      publishers={retailers}
                      selectedPublisherIds={activeCampaign.publisherIds || []}
                      onSubmit={(data) => this.handlePublishersSubmit(data)}
                    />
                  )}
                </CollapsingSection>
                <CollapsingSection
                  open={activeSection === PROMO_CODE_SECTION}
                  onOpenClick={() => this.setState({activeSection:PROMO_CODE_SECTION})}
                  title='Promo Code'
                  subtitle={activePromoCode.code ? formatPromoCode(activePromoCode) : isLoading ? (<i>Loading</i>) : (<i>None applied</i>)}
                  titleWidthInColumns={4}
                >
                  {isLoading ? (
                    <span>Loading<ProgressEllipses /></span>
                  ) : (
                    <CampaignPromoCodeForm
                      feedback={promoCodeFeedback}
                      activePromoCode={activePromoCode}
                      onSubmit={(data) => this.handlePromoCodeSubmit(data)}
                      onDismiss={() => this.setState({activeSection:PAYMENT_SECTION})}
                    />
                  )}
                </CollapsingSection>
                <CollapsingSection
                  open={activeSection ===  PAYMENT_SECTION}
                  onOpenClick={() => this.setState({activeSection:PAYMENT_SECTION})}
                  title='Payment method'
                  subtitle={this.getPaymentSectionSubtitle()}
                  titleWidthInColumns={4}
                  locked={!isCampaignEditable}
                >
                  {isLoading ? (
                    <span>Loading<ProgressEllipses /></span>
                  ) : (
                    <CampaignPaymentForm
                      accountBalance={agencyAccountingBalance}
                      showSuperadminFeatures={showSuperadminFeatures}
                      activePaymentMethodId={activeCampaign.paymentMethodId}
                      defaultPaymentMethodId={activeAgency.defaultPaymentMethodId}
                      onStripeTokenSubmit={(token) => this.handleStripeTokenSubmit(token)}
                      onDefaultCreditCardSubmit={() => this.handleDefaultCreditCardSubmit()}
                      onExistingFundsSubmit={() => this.handleExistingFundsSubmit()}
                    />
                  )}
                </CollapsingSection>
                <br />
                <div>
                  <Button
                    color="primary"
                    disabled={isSaving || invalidEngagementIndexes.length > 0 || !allRequiredFieldsFilled || !isCampaignEditable}
                    onClick={() => this.handleSubmitClick()}
                  >
                    &nbsp;&nbsp;Submit for approval!&nbsp;&nbsp;
                  </Button>
                  &nbsp;&nbsp;
                  <Button onClick={() => this.handleBackClick()}>
                    &nbsp;&nbsp;Back&nbsp;&nbsp;
                  </Button>
                </div>
                <br />
                <br />
              </Col>
            </Row>
          </Col>
          <Col xs='4'>
            <div
              style={{
                position:previewIsFixed ? 'fixed' : 'inherit',
                top:previewIsFixed ? 10 : 0,
                paddingTop:10,
                width:300
              }}
            >
              <PhonePreview
                hideTotalValue
                phonePlatform='generic'
                activeEngagementId={activePreviewEngagementId}
                engagements={activeEngagements}
                feedText={activeCampaign.feedText}
                feedImageURL={activeCampaign.feedImageURL}
                height={previewHeight > MAXIMUM_PREVIEW_HEIGHT ? MAXIMUM_PREVIEW_HEIGHT : previewHeight}
                brandName={activeBrand.name || 'your brand'}
                logoURL={activeBrand.logoURL}
                conclusionText={activeCampaign.completionText}
                conclusionBackgroundColor={activeBrand.primaryColor}
                showQAAnswer={showQAAnswer}
                cta={activeCampaign.useCTA ? {link: activeCampaign.ctaLink, color: activeCampaign.ctaColor, text: activeCampaign.ctaText} : null}
              />
              <br />
              <br />
              <div className='clear-fix'>
                <Button
                  disabled={activePreviewEngagementId === '__FEED__'}
                  onClick={() => this.handlePreviousClick()}
                >
                  Back
                </Button>
                <div
                  id='AdvancePreviewButton'
                  className='pull-right'
                >
                  <Button
                    disabled={activePreviewEngagementId === '__CONCLUSION__'}
                    onClick={() => this.handleNextClick()}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

GuidedCampaignReview.propTypes = {
  //TODO: Fill in prop types for GuidedCampaignReview
};

GuidedCampaignReview.defaultProps = {
  isOnboarding:false,
  allowCreateNewMethod:true
  //TODO: Fill in defaultProps for GuidedCampaignReview
};

export default GuidedCampaignReview;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignReview/components/GuidedCampaignReview.js